//#region IMPORTS
import {
  ArrowUpCircleIcon,
  ArrowDownCircleIcon,
} from "@heroicons/react/24/outline";
import { Tooltip } from "react-tooltip";
//#endregion

//#region INTERFACE
interface Props {
  needHelpMessage?: string;
  clickHandler?: () => void;
  needHelpId?: string;
  order: "asc" | "desc" | "none";
}
//#endregion

export default function MainSortableTableHeaderSortIcon({
  needHelpMessage,
  clickHandler,
  needHelpId,
  order = "none",
}: Props) {
  //#region SETUP

  //#endregion

  //#region RENDER
  return (
    <button
      data-tooltip-id={needHelpId}
      data-tooltip-content={needHelpMessage}
      data-tooltip-place="bottom"
      onClick={clickHandler}
    >
      <div className="flex items-center justify-center">
        {order === "asc" ? (
          <ArrowUpCircleIcon className="w-4 h-4 text-emerald-500" />
        ) : order === "desc" ? (
          <ArrowDownCircleIcon className="w-4 h-4 text-emerald-500" />
        ) : order === "none" ? (
          <ArrowUpCircleIcon className="w-4 h-4 text-gray-300" />
        ) : null}
      </div>
      {needHelpId && <Tooltip id={needHelpId} delayHide={0} />}
    </button>
  );
  //#endregion
}
